import * as t from "io-ts";
import { Money } from "./Money";

export const Income = t.partial({
  income_type: t.union([
    t.literal("earning_after_tax"),
    t.literal("benefits"),
    t.literal("pensions"),
    t.literal("other_sources_of_income"),
  ]),
  income_type_info: t.union([
    t.literal("applicant"),
    t.literal("household"),
    t.literal("not_specified"),
  ]),
  monthly_amount: Money,
});

export interface Income {
  income_type?:
    | "earning_after_tax"
    | "benefits"
    | "pensions"
    | "other_sources_of_income";
  income_type_info?: "applicant" | "household" | "not_specified";
  monthly_amount?: Money;
}
